/**
 * Store and hooks for Simplify Nav New User spotlight state (ACTIVATION-2059).
 * Centralizes hasOpenedCustomize so we can clean up in one place if the experiment is abandoned.
 */
import { createStore, createHook, createActionsHook } from 'react-sweet-state';

import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager/entry-points/storageInstance.ts';
import { keys as localStorageKeys } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';

const getInitialHasOpenedCustomize = (): boolean => {
	try {
		return (
			localStorage?.getItemAsBoolean(
				localStorageKeys.SIMPLIFY_NAV_NEW_USER_SPOTLIGHT_CUSTOMIZE_OPENED,
			) ?? false
		);
	} catch {
		return false;
	}
};

const initialState = {
	hasOpenedCustomize: getInitialHasOpenedCustomize(),
};

export const SimplifyNavNewUserSpotlightStore = createStore({
	initialState,
	actions: {
		setHasOpenedCustomize:
			() =>
			({ setState, getState }) => {
				if (getState().hasOpenedCustomize) {
					return;
				}
				setState({ hasOpenedCustomize: true });
				try {
					localStorage?.setItem(
						localStorageKeys.SIMPLIFY_NAV_NEW_USER_SPOTLIGHT_CUSTOMIZE_OPENED,
						'true',
					);
				} catch {
					// storage unavailable
				}
			},
	},
	name: 'simplifyNavNewUserSpotlightStore',
});

export const useSimplifyNavNewUserSpotlightStore = createHook(SimplifyNavNewUserSpotlightStore, {
	selector: (state) => state.hasOpenedCustomize,
});

export const useSimplifyNavNewUserSpotlightStoreActions = createActionsHook(
	SimplifyNavNewUserSpotlightStore,
);
